const renderCarbonAuto = () => {
  if (document.getElementById("carbonads")) return

  // DEPRECATED snake case in favor of kebab case data-zone-carbon-auto
  const zones1 = document.querySelectorAll("[data-zone-carbon_auto]")
  zones1.forEach(zone => {
    appendScript(zone, zone.getAttribute("data-zone-carbon_auto"), false)
  })

  const zones = document.querySelectorAll("[data-zone-carbon-auto]")
  zones.forEach(zone => {
    appendScript(zone, zone.getAttribute("data-zone-carbon-auto"))
  })
}

const appendScript = (zone, code, cover = true) => {
  const script = document.createElement("script")
  let src = `//cdn.carbonads.com/carbon.js?serve=${code}&placement=carbonadsnet`
  if (cover) src = `${src}&format=cover`

  script.setAttribute("async", "async")
  script.src = src
  script.id = "_carbonads_js"
  zone.appendChild(script)
}

export { renderCarbonAuto }
